import "./AiToolsForManagers.module.css";
import Header from "@/reusable_sections/Header";
import CourseIntroduction from "./sections/CourseIntroduction";
import CourseModules from "./sections/CourseModules";
import LearningOutcomes from "./sections/LearningOutcomes";
import EnrollNow from "./sections/EnrollNow";
import Footer from "@/reusable_sections/Footer";
export default function AiToolsForManagersPage() {
  return <div>
      <Header />
      <CourseIntroduction />
      <CourseModules />
      <LearningOutcomes />
      <EnrollNow />
      <Footer />
    </div>;
}